import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';

import * as api from './api';

import { PostApplicationStateData } from './types';

const initialState: PostApplicationStateData = {
	data: { data: { message: '', error: '' }, error: null },
	loading: false,
	error: '',
};

export const fetchPostApplication = createAsyncThunk(
	'api/fetchPostApplication',
	({ sessionId, theme, application }: { sessionId: string; theme: string; application: string }) =>
		api.fetchPostApplication(sessionId, theme, application),
);

const postApplicationSlice = createSlice({
	name: 'postApplication',
	initialState,
	reducers: {
		clearApplicationResponse(state) {
			state.data = initialState.data;
		},
	},
	extraReducers(builder) {
		builder
			.addCase(fetchPostApplication.pending, (state) => {
				state.loading = true;
				state.error = '';
			})
			.addCase(fetchPostApplication.fulfilled, (state, action) => {
				state.loading = false;
				state.data = action.payload || {};
				state.error = '';
			})
			.addCase(fetchPostApplication.rejected, (state) => {
				state.loading = false;
				state.error = 'Ошибка при отправке заявки';
			});
	},
});

export const { clearApplicationResponse } = postApplicationSlice.actions;
export default postApplicationSlice.reducer;
